import { Icon, Popconfirm, Tooltip } from 'antd';
import React from 'react';
import useBindClient from '../../../mutations/useBindClient';

const TenantViewBtn = ({ tenant, addressId }) => {
  const { mutateAsync, isLoading } = useBindClient();

  const tenatFio = [tenant.surName, tenant.firstName, tenant.patrName]
    .filter(Boolean)
    .join(' ')
    .trim();

  const values = {
    addressId,
    clientId: tenant?.id,
    isOwner: tenant?.isOwner,
    isVerified: tenant?.isShowVerified,
    availableForClient: !tenant?.availableForClient,
  };

  const handleOk = async () => {
    await mutateAsync({ values, tenantName: tenatFio });
  };

  return (
    <Popconfirm
      title="Вы точно хотите изменить видимость адреса в МП?"
      okText="Да"
      cancelText="Нет"
      onConfirm={handleOk}
    >
      <Tooltip
        title="Видимость адреса в МП собственника"
        placement="right"
      >
        {isLoading ? (
          <Icon
            type="loading"
            style={{ fontSize: '16px', color: '#0995ed' }}
          />
        ) : !!tenant?.availableForClient ? (
          <Icon
            type="eye"
            style={{ fontSize: '16px', color: '#0995ed' }}
          />
        ) : (
          <Icon
            type="eye-invisible"
            style={{ fontSize: '16px', color: '#0995ed' }}
          />
        )}
      </Tooltip>
    </Popconfirm>
  );
};

export default TenantViewBtn;
